module.exports = __webpack_public_path__ + "static/concero-bw-ba15acd760c3f4e231de0b27352e9c27.jpg";